
export const successTagColor = "#12a45e"
export const errorTagColor = "#df483d"

export const allTagColors = [
    "#16a257",
    "#ef961f",
    "#2c78b2",
    "#0dbeeb"
]